/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Sample_Show_AllInputs */

const cs_builder_sample_show_all = /** @type {(inputs: Builder_Sample_Show_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobrazit všechna pole`)
};

const en_builder_sample_show_all = /** @type {(inputs: Builder_Sample_Show_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show all fields`)
};

/**
* | output |
* | --- |
* | "Show all fields" |
*
* @param {Builder_Sample_Show_AllInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_sample_show_all = /** @type {((inputs?: Builder_Sample_Show_AllInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Sample_Show_AllInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_sample_show_all(inputs)
	return cs_builder_sample_show_all(inputs)
});